import React, { useContext, useEffect, useRef, useState } from "react";
import { axiosUrl } from "../../api/axios";
import { UserContext } from "../../App";
import "../../styles/layout.scss";

const DepositComp = (props) => {
  const [depositBtns, setDepositBtns] = useState(false);
  const [inputValue, setInputValue] = useState("");
  const [address, setAddress] = useState("");
  const [cryptoType, setCryptoType] = useState("");
  const { userData } = useContext(UserContext);
  const [errMsg, setErrMsg] = useState("");
  const numRef = useRef(null);
  const errRef = useRef(null);
  const [addresses, setAddresses] = useState();

  useEffect(() => {
    const getAddresses = async () => {
      try {
        const res = await axiosUrl.get("/admin", {});
        const addresses = res.data;
        setAddresses(addresses);
      } catch (error) {
        console.log(error);
      }
    };

    getAddresses();
  }, []);

  const cryptoBtnsList = [
    {
      name: "Bitcoin",
      address: addresses?.btcAddress,
      img: "/imgs/bitcoin.png",
    },
    {
      name: "Dogecoin",
      address: addresses?.dogeAddress,
      img: "/imgs/dogecoin.png",
    },
    {
      name: "Ethereum",
      address: addresses?.ethAddress,
      img: "/imgs/eth.png",
    },
    {
      name: "USDT",
      address: addresses?.usdtAddress,
      img: "/imgs/USDT.png",
    },
  ];

  const closeModal = (e) => {
    props.setDepositComp(false);
    setInputValue("");
    setCryptoType("");
  };
  // const openScreenshot = (e) => {
  //   props.setScreenshot(true);
  // };

  const handleChange = (e) => {
    e.preventDefault();
    setInputValue(e.target.value);
  };

  const newDeposit = (e) => {
    e.preventDefault();

    if (inputValue < 500) {
      setErrMsg("Minimum Deposit is $500");
      numRef.current.focus();
      setInputValue("");
      return;
    } else if (!cryptoType) {
      setErrMsg("Select Crytocurrency by clicking any crypto button");
      numRef.current.focus();
      return;
    }
    const newTransaction = {
      userId: `${userData.user.id}`,
      user: `${userData.user.firstName} ${userData.user.lastName}`,
      type: "Deposit",
      amount: inputValue,
      mode: cryptoType,
      status: false,
    };

    axiosUrl.post("/transactions", newTransaction);

    alert("Deposit Sent, Waiting for confirmation");
    closeModal();
    window.location.href = "/dashboard/deposit";
  };

  return (
    <div className="deposit-modal">
      <div className="inner">
        <div className="deposit-title ">
          <h6 className="title">Make a new deposit</h6>
          <i className="fas fa-times" onClick={closeModal}></i>
        </div>

        <div
          ref={errRef}
          className={`${errMsg ? "d-flex" : "d-none"} error-message`}
        >
          <i className="fas fa-exclamation-triangle mx-3"></i>
          <p>{errMsg}</p>
        </div>

        <form onSubmit={newDeposit}>
          <div className="deposit-amount">
            <label htmlFor="deposit-amount-input" className="sharp-text">
              Enter Amount:
            </label>
            <input
              name="deposit-amount-input"
              type="number"
              placeholder="$"
              onFocus={() => setDepositBtns(true)}
              value={inputValue}
              onChange={handleChange}
              required
              ref={numRef}
            />
          </div>
          <div
            className={`deposit-amount-btns ${
              depositBtns ? "show-deposit-btns" : ""
            }`}
          >
            {depositBtnsList.map((btn) => (
              <button
                key={btn.amount}
                className="btn btn-warning rounded-0"
                onClick={() => {
                  setInputValue(btn.amount);
                  numRef.current.focus();
                }}
                type="button"
              >
                {btn.amount}
              </button>
            ))}
          </div>

          <p className="sharp-text select-crypto-text">
            Select a cryptocurrency below
            <span>
              {" "}
              <i className="fas fa-arrow-down"></i>
            </span>
          </p>

          <div className="select-crypto-btns">
            {cryptoBtnsList.map((btn) => (
              <div
                key={btn.name}
                className="select-crypto-btn"
                onClick={() => {
                  setAddress(btn.address);
                  setCryptoType(btn.name);
                  setErrMsg(false);
                }}
              >
                <img src={btn.img} alt="" />
                <p className="sharp-text">{btn.name}</p>
              </div>
            ))}
          </div>

          <div className={`crypto-address ${address === "" ? "d-none" : ""}`}>
            <small className="error-message m-0 mb-2 fw-bold">
              Send the amount of crypto you want to deposit to the address below
            </small>
            <div className="address">
              <p className="fw-bold">{cryptoType} Address:</p>
              <p className="title sharp-text">{address}</p>
              <div
                className="copy-address"
                onClick={() => {
                  navigator.clipboard
                    .writeText(address)
                    .then(() => {
                      alert(`${cryptoType} Address Copied to clipboard`);
                    })
                    .catch(() => {
                      alert("Something went wrong");
                    });
                }}
              >
                <i className="fas fa-copy"></i>
                <p className="">Copy</p>
              </div>
            </div>
          </div>

          <div className="sumbit-btn">
            <button type="submit" className="btn btn-primary rounded">
              SENT
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default DepositComp;

const depositBtnsList = [
  {
    amount: "500",
  },
  {
    amount: "1000",
  },
  {
    amount: "2000",
  },
  {
    amount: "5000",
  },
  {
    amount: "10000",
  },
  {
    amount: "20000",
  },
  {
    amount: "50000",
  },
];
